import { styles } from "./content_card";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { colors } from "../../utils/const";
import Link from "next/link";
import Image from "next/image";
import { useI18n } from "@/i18n/I18nProvider";
import { getOurBrandsText } from "../../../locales/our-brands";

export default function BottomCard({
  img,
  content,
  link1,
  link2,
  link3,
  id,
  topLine,
  heading,
  supervision,
}) {
  const { t, locale } = useI18n();
  const ourBrandsText = getOurBrandsText(locale);

  return (
    <Box
      sx={styles.container}
      style={{
        borderTop: topLine ? "1px solid #e4e7ec" : "1px solid transparent",
        paddingTop: topLine ? "30px" : "30px",
      }}
    >
      <Image
        quality={100}
        src={img}
        alt={heading}
        width={80}
        height={70}
        style={{ height: "auto" }}
      />

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "column",
            gap: heading ? 1 : 0,
          }}
        >
          <Typography
            component="h3"
            sx={{ color: colors.blue, fontWeight: "600" }}
          >
            {" "}
            {heading}
          </Typography>
          <Typography> {content}</Typography>
          <Typography sx={{ color: colors.bastille, fontWeight: "600" }}>
            {supervision}
          </Typography>
        </Box>

        <Box sx={{ position: "relative", display: "inline-block", zIndex: 1 }}>
          {/* Overlay */}
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              backgroundColor: "rgba(0, 0, 0, 0.0)",
              zIndex: -1,
            }}
          />

          {/* Links */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "20px",
              flexWrap: "wrap",
            }}
          >
            {link1 && (
              <Box
                component={Link}
                target="_blank"
                href={link1}
                sx={styles.link}
              >
                {ourBrandsText.our_brand_page.link1}
              </Box>
            )}
            {link2 && (
              <Box
                component={Link}
                target="_blank"
                href={link2}
                sx={styles.link}
              >
                {ourBrandsText.our_brand_page.link2}
              </Box>
            )}
            {link3 && (
              <Box
                component={Link}
                target="_blank"
                href={link3}
                sx={styles.link}
              >
                {ourBrandsText.our_brand_page.link3}
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
